import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = {
  id: "edit-alert",
  class: "form"
}
const _hoisted_3 = { class: "custom-select multiselect_bullet_tags links" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Document Type Id ", -1)
const _hoisted_5 = { class: "action-buttons" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, { success: _ctx.success }, null, 8, ["success"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", _hoisted_2, [
        _createVNode(_component_TextInput, {
          type: "text",
          label: "Alert ID",
          max: 50,
          modelValue: _ctx.alert.AlertTypeID,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.alert.AlertTypeID) = $event)),
          readonly: true
        }, null, 8, ["modelValue"]),
        _createVNode(_component_SelectComponent, {
          label: "Fund Type",
          selectedOption: _ctx.alert.FundType,
          "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.alert.FundType) = $event)),
          options: _ctx.fundTypes,
          "single-arrow": true
        }, null, 8, ["selectedOption", "options"]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.alert.Documents,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.alert.Documents) = $event)),
            options: _ctx.documents,
            placeholder: "Type to search",
            multiple: true,
            "hide-selected": true,
            "track-by": "CodeID",
            label: "Description",
            searchable: true,
            "close-on-select": true,
            taggable: true,
            onSearchChange: _ctx.handleDocumentSearch
          }, null, 8, ["modelValue", "options", "onSearchChange"])
        ]),
        _createVNode(_component_TextInput, {
          type: "text",
          label: "Type",
          max: 50,
          modelValue: _ctx.alert.Name,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.alert.Name) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_Textarea, {
          label: "Message",
          modelValue: _ctx.alert.Message,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.alert.Message) = $event)),
          customClass: "fw-light fs-small"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"])),
            class: "btn btn-secondary"
          }, " Cancel "),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: _ctx.loadingSubmit,
            onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.loadingSubmit ? 'Saving...' : 'Save'), 9, _hoisted_6)
        ])
      ])
    ])
  ], 64))
}